import {BASE_URL} from '../../api'
import API_LINKS from '../../constant/api.links'
import config from '../config'

const {axios} = config
const useAuth = () => {
  // Requests

  const getAdmin = async () => {
    try {
      const API_URL = BASE_URL + API_LINKS.GET_ADMIN

      const {data, status} = await axios.get(API_URL)
      return {data, status}
    } catch (error: any) {
      throw new Error(error.message)
    }
  }
  // Get OTP
  const getOtp = async (email: string) => {
    try {
      return {}
    } catch (error: any) {
      return new Error(error.message)
    }
  }

  const verifyOtp = async (email: string, otp: string) => {
    try {
      return {}
    } catch (error: any) {
      console.log(error, 'err')
      return new Error(error.message)
    }
  }

  const forgotPassword = async (email: string, password: string) => {
    try {
      return {}
    } catch (error: any) {
      return new Error(error.message)
    }
  }

  return {getOtp, verifyOtp, forgotPassword, getAdmin}
}

export default useAuth
